const firebaseConfig = {
    apiKey: 'AIzaSyC68yh6mIPbK5C6L4RByA4vvDeY8EFDDCo',
    authDomain: 'local-courier-c90ba.firebaseapp.com',
    projectId: 'local-courier-c90ba',
    storageBucket: 'local-courier-c90ba.appspot.com',
    messagingSenderId: '413674971934',
    appId: '1:413674971934:web:7d7a04c75334ea72789f0f',
};
export default firebaseConfig;
